export enum PermissionsGroups {
  TACTICS,
  FUNNELS,
  TEAMS,
}
